import React, {useState, useEffect} from 'react';
import {animateScroll as scroll} from 'react-scroll';
import {IconContext} from "react-icons";
import {
    MobileIcon,
    Nav,
    NavbarContainer,
    NavItem,
    NavLinks,
    NavLogo,
    NavMenu
} from "./NavbarElements";
import {FaBars} from "react-icons/all";

const Navbar = ({toggle}) => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if(window.scrollY >= 80){
            setScrollNav(true);
        } else{
            setScrollNav(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', changeNav);
    }, []);

    const toggleHome = ()=> {
        scroll.scrollToTop();
    }

    return(
        <>
            <IconContext.Provider value={{color: '#fff'}}>
                <Nav scrollNav={scrollNav}>
                    <NavbarContainer>
                        <NavLogo to='/' onClick={toggleHome}>Home</NavLogo>
                        <MobileIcon onClick={toggle}>
                            <FaBars/>
                        </MobileIcon>
                        <NavMenu>
                            <NavItem>
                                <NavLinks to='about'
                                          smooth = {true}
                                          duration={500} spy={true}
                                          offset={-80}
                                          activeClass='active'>
                                    About
                                </NavLinks>
                            </NavItem>
                            <NavItem>
                                <NavLinks to='myWorks'
                                          smooth = {true}
                                          duration={500} spy={true}
                                          offset={-80}
                                          activeClass='active'>
                                    My Works
                                </NavLinks>
                            </NavItem>
                            <NavLinks to='contactMe'
                                      smooth = {true}
                                      duration={500} spy={true}
                                      offset={-80}
                                      activeClass='active'>
                                Contact Me
                            </NavLinks>
                            <NavItem>

                            </NavItem>
                        </NavMenu>
                        {/*<NavBtn>
                            <NavBtnLink
                                smooth={true} duratiion={500}
                                spy={true} exact='true'
                                offset={-80} activeClass='active'
                                to='/contactMe'>Contact Me</NavBtnLink>
                        </NavBtn>*/}
                    </NavbarContainer>
                </Nav>
            </IconContext.Provider>
        </>
    )
}

export default Navbar;
